import type { NotifyPort } from '@/features/messages/domain/notify'
import type { ChatPort, Topic } from '../domain/chat'

const startP2P = async (port: ChatPort, peerId: string, notify: NotifyPort): Promise<Topic | null> => {
	try {
		return await port.startP2P(peerId)
	} catch {
		notify.error('chat.conversationStartFailed')
		return null
	}
}

export { startP2P }
